module.exports = __webpack_public_path__ + "media/images/svg/logo_antanyo-a349f49ac6bb6b336829af307a52c6a6.svg";